import { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter } from "lucide-react";
import { Logo } from "@/components/Logo";
import api from "@/lib/api";
import { toast } from "sonner";

const cols = [
  { title: "Shop", items: [["Men", "/shop?audience=men"], ["Boys", "/shop?audience=boys"], ["New Arrivals", "/shop?new_arrival=true"], ["Festive Edit", "/shop?occasion=Festive"]] },
  { title: "Help", items: [["Contact Us", "/contact"], ["Shipping & Returns", "/contact"], ["Size Guide", "/shop"], ["Track Order", "/account"]] },
  { title: "The House", items: [["Our Story", "/about"], ["Lookbook", "/lookbook"], ["Craftsmanship", "/about"]] },
];

export function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("Welcome to the KKashigari family");
      setEmail("");
    } catch {
      toast.error("Please enter a valid email");
    }
  };

  return (
    <footer className="bg-[#F3EECB] border-t border-[var(--line)] mt-24">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">
          <div className="lg:col-span-2 space-y-5">
            <Logo className="h-14" />
            <p className="text-sm text-[var(--olive)] max-w-xs leading-relaxed">
              Contemporary Indian ethnic wear — kurtas & kurta sets woven with heritage, tailored for today.
            </p>
            <div className="flex gap-3">
              {[Instagram, Facebook, Twitter].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 grid place-items-center border border-[var(--line)] rounded-full text-[var(--bronze)] hover:bg-[var(--olive)] hover:text-[#FBF7DE] transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <div className="uplabel mb-5">{c.title}</div>
              <ul className="space-y-3">
                {c.items.map(([label, to]) => (
                  <li key={label}><Link to={to} className="text-sm text-[var(--bronze)] hover:text-[var(--olive)] transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <form onSubmit={submit} data-testid="footer-newsletter" className="mt-14 pt-10 border-t border-[var(--line)] flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
          <div>
            <div className="font-serif text-2xl text-[var(--bronze)]">Join The Atelier</div>
            <p className="text-sm text-[var(--olive)]">Early access to new drops & festive edits.</p>
          </div>
          <div className="flex items-center border-b border-[var(--olive)] w-full sm:w-80">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address" data-testid="footer-newsletter-input"
              className="bg-transparent flex-1 py-2 text-sm outline-none text-[var(--bronze)] placeholder:text-[var(--olive)]/60" />
            <button type="submit" data-testid="footer-newsletter-submit" className="uplabel text-[var(--bronze)] hover:text-[var(--olive)] transition-colors">Subscribe</button>
          </div>
        </form>
      </div>
      <div className="border-t border-[var(--line)] py-6 text-center text-xs text-[var(--olive)]">
        © {new Date().getFullYear()} KKashigari India. Crafted with care. · Secure Payments · COD Available
      </div>
    </footer>
  );
}
